export default __webpack_public_path__ + "static/media/167.0490b9b7.png";